import { Component, Input, output, Renderer2, signal, input } from "@angular/core";
import { sleep } from "../../../util/sleep.util";
import { SelectionListItem } from "../../../model/selectionlistitem";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html'
})
export class DropdownComponent {
  static TOGGLE_DELAY_MS = 50;

  readonly optional = input<boolean>();
  readonly disabled = input<boolean>();
  @Input() label?: string;
  @Input() inlineLabel?: string;
  @Input() translationPrefix?: string;
  @Input() hasSelectedItem?: boolean;
  @Input() selectedItemDisplayName: string;
  readonly items = input<Array<SelectionListItem | any>>();
  readonly inlineHeader = input<string>();
  @Input() description?: string;
  readonly appColor = input("unset");
  readonly makeChoiceLabel = input(this.translate.instant("INCLUDE_CONFIGSTEP_LABEL_MAKE_CHOICE"));

  itemSelected = output<any>();

  deselectOption = {};
  // signal, because it is changed after a delay and from document listeners outside the template
  readonly expanded = signal(false);

  private onClickListener;
  private onKeyDownListener;

  constructor(private renderer: Renderer2,
              private translate: TranslateService) {
  }

  selectItem(value: any) {
    this.itemSelected.emit(value);
    this.hasSelectedItem = this.deselectOption !== value;
    this.deregisterListeners();
  }

  async toggleItems(forceHide = false) {
    if (this.disabled()) {
      return;
    }
    await sleep(DropdownComponent.TOGGLE_DELAY_MS);
    this.expanded.set(forceHide ? false : !this.expanded());

    // add/remove an on-demand listener to hide the expanded items when clicking outside the element
    if (this.expanded()) {
      if (!this.onClickListener) {
        // https://angular.io/api/core/Renderer2#listen
        this.onClickListener = this.renderer.listen(document, "click", () => {
          this.toggleItems(true);
        });
        // when hitting escape, we hide the dropdown
        this.onKeyDownListener = this.renderer.listen(document, "keydown", event => {
          const code = event.keyCode || event.which;
          if (code === 27) {
            this.toggleItems(true);
          }
        });
      }
    } else {
      this.deregisterListeners();
    }
  }

  private deregisterListeners(): void {
    if (this.onClickListener) {
      this.onClickListener(); // 'unlisten'
      this.onClickListener = undefined;
    }
    if (this.onKeyDownListener) {
      this.onKeyDownListener(); // 'unlisten'
      this.onKeyDownListener = undefined;
    }
  }
}
